// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type HomeownerNotesTileQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type HomeownerNotesTileQuery = { __typename?: 'Query', homeownerNotes: Array<{ __typename?: 'HomeownerNote', id: string, createdAt: Types.Scalars['DateTime']['input'], title: string, createdBy: { __typename?: 'User', avatarUrl: string, id: string, name: string } }> };

export type HomeownerNoteTileFragment = { __typename?: 'HomeownerNote', id: string, createdAt: Types.Scalars['DateTime']['input'], title: string, createdBy: { __typename?: 'User', avatarUrl: string, id: string, name: string } };

export const HomeownerNoteTileFragmentDoc = gql`
    fragment HomeownerNoteTile on HomeownerNote {
  id
  createdAt
  createdBy {
    avatarUrl
    id
    name
  }
  title
}
    `;
export const HomeownerNotesTileDocument = gql`
    query HomeownerNotesTile($projectId: ID!) {
  homeownerNotes(filter: {project: [$projectId]}, limit: 15) {
    ...HomeownerNoteTile
  }
}
    ${HomeownerNoteTileFragmentDoc}`;

/**
 * __useHomeownerNotesTileQuery__
 *
 * To run a query within a React component, call `useHomeownerNotesTileQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeownerNotesTileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeownerNotesTileQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useHomeownerNotesTileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HomeownerNotesTileQuery, HomeownerNotesTileQueryVariables> & ({ variables: HomeownerNotesTileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HomeownerNotesTileQuery, HomeownerNotesTileQueryVariables>(HomeownerNotesTileDocument, options);
      }
export function useHomeownerNotesTileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HomeownerNotesTileQuery, HomeownerNotesTileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HomeownerNotesTileQuery, HomeownerNotesTileQueryVariables>(HomeownerNotesTileDocument, options);
        }
export function useHomeownerNotesTileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomeownerNotesTileQuery, HomeownerNotesTileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HomeownerNotesTileQuery, HomeownerNotesTileQueryVariables>(HomeownerNotesTileDocument, options);
        }
export type HomeownerNotesTileQueryHookResult = ReturnType<typeof useHomeownerNotesTileQuery>;
export type HomeownerNotesTileLazyQueryHookResult = ReturnType<typeof useHomeownerNotesTileLazyQuery>;
export type HomeownerNotesTileSuspenseQueryHookResult = ReturnType<typeof useHomeownerNotesTileSuspenseQuery>;
export type HomeownerNotesTileQueryResult = Apollo.QueryResult<HomeownerNotesTileQuery, HomeownerNotesTileQueryVariables>;